<template lang="pug">
  .main-modal-mask.relative.z-400(v-if="show" @click.self="closeModal()")
    .main-modal-block.absolute.transform(class="-translate-y-1/2 -translate-x-1/2 top-1/2 left-1/2" )
      .modal-content-box.overflow-hidden.m-auto(:style="{'padding': padding, 'max-width' :  maxWidth}" :class="styleRounded()" )
        .modal-header
          slot(:name="header" v-if="header")
          .flex.justify-between(v-else)
            div {{headerTitle}}
            span.pt-20.cursor-pointer(@click="closeModal('X')") 
              iCon.h-18.w-18.text-grey-border(iconClass="close" type="svg")
        .modal-body
          slot(:name="body" v-if="body")
          div(v-else) 
            div {{bodyContent}}
        .modal-footer
          slot(:name="footer" v-if="footer")
          //md:w-500 :class="getClass()"
</template>

<script>
// import Button from '@/components/common/Button.vue';
import { globalFixed } from '@/utils/mixin'


export default {
  name: 'Modal',
  components: {
    // Button,
  },
  props: {
    type: String,
    rounded: {
      type: String,
      default: '12',
    },
    show: {
      type: Boolean,
      required: true,
    },
    headerTitle: String,
    bodyContent: String,
    header: String,
    body: String,
    footer: String,
    clickOutSideClose: {
      type: Boolean,
      default: true,
    },
    padding: String,
    maxWidth:{
      type: String,
      default: '500px',
    }
    
  },
  mixins: [globalFixed],
  data() {
    return {
      isShow: this.show,
    };
  },
  methods: {
    closeModal(word, type = ''){
      if(this.clickOutSideClose || type != '' || word){
          this.isShow = false;
      }else{
        this.isShow = true;
      }
      this.$emit('closeModal', this.isShow);
    },
    styleRounded(){
      let result = [];
      result.push(`rounded-${this.rounded}`)
      return result;
    },
  },

  computed: {
    getClass() {
      let result = '';
      result = 'border-gray-1200 ';
      
      return result;
    },
  },
  watch:{
    'show': function (n){
      this.isFixed(n, 'fixed');
      // this.$root.frozen  = n ; 
      
    }
  }
};
</script>

<style lang="scss" scoped>

.main-modal-mask{
  width: 100vw;
  @apply  fixed top-0 right-0 bottom-0 left-0 bg-modal;
  .main-modal-block{
    width: 100%;
    @apply block m-auto ;
    .modal-content-box{
      width: 100%;
      @apply bg-white shadow-modal py-32 px-32 ;
    }
  }
}

</style>